(() => {
  const selector = '.product-details input[name="quantity"]';

  function parsePrice(text) {
    const raw = (text || '').replace(/\u00a0/g, ' ').trim();
    const matches = raw.match(/[\d\s\u202f.,]+/g);
    if (!matches) return null;
    const numericSource = [...matches].reverse().find((value) => /\d/.test(value));
    if (!numericSource) return null;
    const firstDigit = raw.lastIndexOf(numericSource);
    const prefix = raw.slice(0, firstDigit).replace(/[^€$£¥A-Z]+$/i, '');
    const numeric = numericSource.replace(/[\s\u202f]/g, '');
    const comma = numeric.lastIndexOf(',');
    const dot = numeric.lastIndexOf('.');
    let decimalIndex = Math.max(comma, dot);
    if (decimalIndex >= 0 && numeric.length - decimalIndex - 1 !== 2) decimalIndex = -1;
    const integerPart = decimalIndex >= 0
      ? numeric.slice(0, decimalIndex).replace(/[^\d]/g, '')
      : numeric.replace(/[^\d]/g, '');
    const decimalPart = decimalIndex >= 0
      ? numeric.slice(decimalIndex + 1).replace(/[^\d]/g, '').padEnd(2, '0').slice(0, 2)
      : '00';
    const cents = Number(integerPart || 0) * 100 + Number(decimalPart);
    if (!Number.isFinite(cents)) return null;
    const symbolMatch = raw.match(/[€$£¥]|[A-Z]{3}/);
    return { cents, symbol: symbolMatch?.[0] || '€', symbolFirst: symbolMatch ? symbolMatch.index < raw.search(/\d/) : false };
  }

  function formatMoney(cents, template) {
    const amount = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(cents / 100);
    return template.symbolFirst ? `${template.symbol}${amount}` : `${amount} ${template.symbol}`;
  }

  function setVisibleText(element, value) {
    for (const node of [...element.childNodes]) {
      if (node.nodeType === Node.TEXT_NODE) node.remove();
    }
    element.append(document.createTextNode(value));
  }

  function ensureStyles() {
    if (document.getElementById('ninja-discount-total-styles')) return;
    const style = document.createElement('style');
    style.id = 'ninja-discount-total-styles';
    style.textContent = `
      .ninja-discount-badge {
        display: inline-flex;
        align-items: center;
        margin-inline-start: .55rem;
        padding: .22rem .55rem;
        border: 1px solid rgba(163, 230, 53, .6);
        border-radius: 999px;
        background: rgba(163, 230, 53, .14);
        color: #b9f45b;
        font-size: .78em;
        font-weight: 800;
        line-height: 1.2;
        vertical-align: middle;
        white-space: nowrap;
      }
    `;
    document.head.append(style);
  }

  function setup(input) {
    if (input.dataset.ninjaTotalReady === 'true') return;
    const details = input.closest('.product-details');
    const productPrice = details?.querySelector('product-price');
    const container = productPrice?.querySelector('[ref="priceContainer"]');
    if (!productPrice || !container) return;

    const saleElement = () => container.querySelector('.price');
    const compareElement = () => container.querySelector('.compare-at-price');
    const sale = parsePrice(saleElement()?.textContent);
    const compare = parsePrice(compareElement()?.textContent);
    if (!sale) return;

    input.dataset.ninjaTotalReady = 'true';
    const state = {
      sale,
      compare,
      internal: false,
      renderedSale: '',
      renderedCompare: '',
    };

    const badge = document.createElement('span');
    badge.className = 'ninja-discount-badge';
    badge.setAttribute('aria-label', 'Pourcentage de réduction');

    const render = () => {
      const quantity = Math.max(1, Number.parseInt(input.value, 10) || 1);
      const saleNode = saleElement();
      if (!saleNode) return;

      state.internal = true;
      state.renderedSale = formatMoney(state.sale.cents * quantity, state.sale);
      setVisibleText(saleNode, state.renderedSale);
      saleNode.setAttribute('aria-label', `Prix promotionnel total pour ${quantity} article${quantity > 1 ? 's' : ''} : ${state.renderedSale}`);

      const compareNode = compareElement();
      if (state.compare && compareNode && state.compare.cents > state.sale.cents) {
        state.renderedCompare = formatMoney(state.compare.cents * quantity, state.compare);
        setVisibleText(compareNode, state.renderedCompare);
        compareNode.setAttribute('aria-label', `Prix initial total pour ${quantity} article${quantity > 1 ? 's' : ''} : ${state.renderedCompare}`);
        const percent = Math.round((1 - state.sale.cents / state.compare.cents) * 100);
        badge.textContent = `−${percent} %`;
        if (!badge.isConnected) compareNode.insertAdjacentElement('afterend', badge);
      } else {
        badge.remove();
      }
      requestAnimationFrame(() => { state.internal = false; });
    };

    const refreshUnitPrices = () => {
      if (state.internal) return;
      const saleNode = saleElement();
      const compareNode = compareElement();
      const saleText = saleNode?.textContent.trim() || '';
      const compareText = compareNode?.textContent.trim() || '';
      if (saleText && !saleText.includes(state.renderedSale)) {
        const nextSale = parsePrice(saleText);
        if (nextSale) state.sale = nextSale;
      }
      if (compareNode && compareText && !compareText.includes(state.renderedCompare)) {
        state.compare = parsePrice(compareText);
      } else if (!compareNode) {
        state.compare = null;
      }
      render();
    };

    input.addEventListener('input', render);
    input.addEventListener('change', render);
    input.closest('quantity-selector-component')?.addEventListener('click', () => setTimeout(render, 0));
    new MutationObserver(refreshUnitPrices).observe(productPrice, { childList: true, subtree: true, characterData: true });
    render();
  }

  function init() {
    ensureStyles();
    document.querySelectorAll(selector).forEach(setup);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
  init();
})();